export default __webpack_public_path__ + "static/media/234.0fe5ae37.jpg";